import Changelog from './Changelog';

export default Changelog;
